import { render, staticRenderFns } from "./customer-setting.vue?vue&type=template&id=0d564f4c&scoped=true&"
import script from "./customer-setting.vue?vue&type=script&lang=js&"
export * from "./customer-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d564f4c",
  null
  
)

export default component.exports